<template>
  <div class="container">
    <div class>
      <div class="mt-100 container-style mb-100 pb-40">
        <studyFeatureHeader></studyFeatureHeader>

        <div v-if="consentData.opType === 'toAdd'">
          <editMultiConsent :options="consentData" :existingConsent="existingConsents" @exit="closeModal" @autoSaveReset="resetAutoSave" @consentDataSend="consentDataRecived"></editMultiConsent>
        </div>

        <div v-if="consentData.opType === 'toEdit'">
          <editMultiConsent :options="consentData" :existingConsent="existingConsents" @exit="closeModal" @autoSaveReset="resetAutoSave" @consentDataSend="consentDataRecived"></editMultiConsent>
        </div>

        <div v-if="consentData.opType === 'toOptionalEdit'">
          <editMultiConsent
           :options="consentData"
           :existingConsent="existingConsents"
           :dataVantConsentBasicDetails=" this.dataVantConsentBasicDetails"
           @exit="closeModal"
           @autoSaveReset="resetAutoSave" 
           @consentDataSend="consentDataRecived">
          </editMultiConsent>
        </div>

        <div v-if="privacyReadMode">
          <privacyPolicy :operationType="privacyPolicyOPType" :privacyPolicyData="privacyPolicy" @save="savePrivacyPolicy" @cancel="cancelEditingPrivacyPolicy" @delete="deletePrivacyPolicy"></privacyPolicy>
        </div>

        <div v-if="licenseReadMode">
          <licenseAgreement @done="closeLicenseAgreementReading" :option="licenses"></licenseAgreement>
        </div>

        <!-- Study consenting section - STARTS -->

        <study-consent-type-section v-show="multiconsent.box1" :studyDetails="studyDataFacts" :datavantStatus="isDatavantTokenizationEnabled" @set-study-consent-type="switchEConsent( $event )" />

        <!-- Study consenting section - ENDS -->

        <div class="consent-cohort-section" v-if="multiconsent.box1" v-bind:class="{ 'disable-consent': !toggleEConsent }">
          <!-- Consents start here :  -->
          <div class="multiconsent-box1">
            <div>
              <span class="multiconsent-box1-heading1">
                Consents and agreements
              </span>
            </div>
            <div class="multiconsent-box1-content1">
              All consents and/or agreements required for this study. This may include the general study consent, child assent, HIPAA authorization, etc.
            </div>
            <div class="multiconsent-box1-btn1">
              <button
                class="add-consent-btn white-btn"
                v-bind:class="{
                  'disabled-icon': !studyDataFacts.consentEnabled
                }"
                v-on:click="addNewConsent()"
              >
                Add a consent or agreement
              </button>
            </div>
            <div class="multiconsent-box1-divider"></div>
            <template v-if="existingConsents.length > 0">
              <draggable v-model="existingConsents" v-for="(v, key) in existingConsents" v-bind:key="key" class="multiconsent-box1-bottom">
                <div class="left-block">
                  <span class="consent-name">{{ v.consentName }}</span>
                </div>

                <div class="right-block">
                  <span
                    class="link"
                    v-bind:class="{
                      'disabled-icon': !studyDataFacts.consentEnabled
                    }"
                    v-on:click="editConsent(v)"
                    >Edit</span
                  >
                  <span
                    class="edit-icon"
                    v-bind:class="{
                      'disabled-icon': !studyDataFacts.consentEnabled
                    }"
                    v-on:click="deleteConsent(v)"
                  >
                    <img src="static/img/econsent/collapse_consent.svg" />
                  </span>
                </div>

                <div class="clearfix"></div>
              </draggable>
            </template>
            <div class="multiconsent-box1-content2" v-if="existingConsents.length === 0">
              No consents added
            </div>
          </div>
          <!-- Consents end here -->
          <div class="consent-sub-section-divider"></div>
          <!-- Optional Consents and agreements start here -->
         <div class="optionalmulticonsent-box1" v-if="isDatavantTokenizationEnabled">
          <div class="optionalmulticonsent-box1-heading1"> Optional Consents and agreements
          </div>
          <div class="optionalmulticonsent-box1-content1">These consents are optional for this study and may include
            consents related to secondary research, real world data, etc
          </div>
          <div class="multiconsent-box1-divider"></div>
            <div class="multiconsent-box1-bottom">
              <div class="left-block optionalmulticonsent-box1-content2 required-field"> Datavant Tokenization Consent                 
              </div>  
              <div class="right-block">               
                 <span class="link" v-on:click="checkDatavantConsentAndGetDetails()">Edit</span>
              </div> 
              <div class="clearfix"></div>
            </div>
          <div class="clearfix"></div>
        </div>
        <div class="consent-sub-section-divider"></div>
         <!-- Optional Consents and agreements end here -->
          <!-- Cohorts start here :  -->
          <div class="multiconsent-box2">
            <div class="multiconsent-box2-heading1">
              Assign consents and agreements
            </div>
            <div class="multiconsent-box2-content1">
              Assign the consents and/or agreements you have created to your participants. You may create multiple cohorts and assign them different consents/agreements. If you have more than one cohort, your participants will be asked to select the cohort that best describes them.
            </div>
            <div class="multiconsent-box2-btn1" v-if="cohorts.addButton">
              <button
                class="white-btn add-cohort-btn"
                v-bind:class="{
                  'disabled-icon': !studyDataFacts.consentEnabled
                }"
                v-on:click="addNewCohort()"
              >
                Add a cohort
              </button>
            </div>
            <div v-if="cohort.opType === 'toAdd'">
              <addEditCohort :options="cohort" :existingCohort="existingCohorts" @cancel="cancelEditing" @save="saveCohort"></addEditCohort>
            </div>
            <div v-if="cohort.opType === 'toEdit'">
              <addEditCohort :options="cohort" :existingCohort="existingCohorts" @cancel="cancelEditing" @save="saveCohort"></addEditCohort>
            </div>
            <div class="multiconsent-box2-divider"></div>
            <div class="multiconsent-box2-bottom">
              <div v-if="existingCohorts.length > 0">
                <div v-for="(v, key) in existingCohorts" v-bind:key="key" class="multiconsent-box1-bottom">
                  <div v-if="cohort.editCurrentCohort === 'toEdit' && cohort.cohortId === v.cohortId">
                    <cohortConsentAssociation :cohort="v" :existingCohort="existingCohorts" @cancelEditing="cancelAssociationEditing" @deleteCohort="deleteCohort"></cohortConsentAssociation>
                  </div>
                  <div v-else v-bind:class="{ 'disable-row': isDisable }">
                    <div class="left-block">
                      <div class="multiconsent-box2-content2">
                        {{ v.cohortName }}
                      </div>
                      <div class="cohort-consent-name" v-if="v.associatedConsent != null">
                        {{ v.associatedConsent.map(item => item.consentName).join(" > ") }}
                      </div>
                    </div>
                    <div class="right-block">
                      <div v-if="v.associatedConsent != null && v.associatedConsent.length > 0" style="display:inline-block;">
                        <span
                          class="link"
                          v-bind:class="{
                            'disabled-icon': !studyDataFacts.consentEnabled
                          }"
                          v-on:click="editCohort(v)"
                          >Edit</span
                        >
                      </div>
                      <div v-else style="display:inline-block;">
                        <button class="colored-btn select-consent-btn" v-on:click="editCohort(v)">
                          Select consents
                        </button>
                      </div>
                      <span
                        class="edit-icon"
                        v-bind:class="{
                          'disabled-icon': !studyDataFacts.consentEnabled
                        }"
                        v-on:click="deleteCohort(v)"
                      >
                        <img src="static/img/econsent/collapse_consent.svg" />
                      </span>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="multiconsent-box2-content1">
                  No cohort available
                </div>
              </div>
            </div>
          </div>
          <!-- Cohorts end here -->
        </div>
        <div class="multiconsent-box3" v-if="multiconsent.box2">
          <div class="d-flex">
            <div class="mr-auto multiconsent-box3-heading1">Legal</div>
            <div class="required-box">Required</div>
          </div>
          <div class="multiconsent-box3-divider"></div>
          <div class="multiconsent-box3-bottom1">
            <div class="left-block">
              <div class="multiconsent-box3-bottom1-content1">
                Privacy Policy
              </div>
            </div>
            <div class="right-block" v-if="privacyPolicy == ''">
              <button class="white-btn add-privacy-policy-btn" v-on:click="addPrivacyPolicy()">
                Add privacy policy
              </button>
            </div>
            <div class="right-block" v-else>
              <button class="white-btn add-privacy-policy-btn" v-on:click="editPrivacyPolicy()">
                Edit a privacy policy
              </button>
            </div>
            <div class="clearfix"></div>
          </div>

          <div class="multiconsent-box3-bottom2">
            <div class="left-block">
              <div class="multiconsent-box3-bottom2-content1">
                THREAD Study Application End User License Agreement
              </div>
            </div>
            <div class="right-block">
              <span class="link" v-on:click="viewLicenseAgreement()">View</span>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>

        <div class="footerStyle">
          <div class="container">
            <div class="row">
              <div class="row" v-if="isStudySummary">
                <b-btn class="btn nextBtn float-left br-25" @click="cancelModify">Cancel modifying</b-btn>
                <button class="btn br-25 continue-btn mr-10" v-on:click="nextClick()">
                  Save and Continue
                </button>
                <b-btn class="btn br-25 disable-btn p-0 pt-5 mr-10" :to="{ name: 'study-summary', params: { studyId: studyId } }">Back to study summary</b-btn>
              </div>
              <div class="row" v-if="!isStudySummary">
                <button class="btn br-25 disable-btn mr-10" style="float:none;" v-on:click="skipForNow()">
                  Skip for now
                </button>
                <button class="btn nextBtn br-25" v-on:click="nextClick()">
                  Save and Continue
                </button>
              </div>
            </div>
          </div>
        </div>
        <CancelModal ref="cancelConfirmation" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import toastr from "toastr";
import draggable from "vuedraggable";
import swal from "sweetalert2";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import studyFeatureHeader from "../common/study-features-header";
import addEditCohort from "../common/add-edit-cohort";
import cohortConsentAssociation from "../common/cohort-consent-association";
import privacyPolicy from "../common/add-edit-multi-consent-privacy-policy";
import licenseAgreement from "../common/view-license-agreement";
import editMultiConsent from "../common/edit-multi-consent";
import CancelModal from "./cancel-modify-modal";
import StudyConsentTypeSection from "./study-consent-type-section";
import registration from "./registration.vue";
import DatavantTokenizationModal from "../modals/datavant-tokenization-modal";
import * as DatavantService from "@/services/datavant-service";
import { studyId } from '../../api/urls';


export default {
  name: "multieconsent",
  data() {
    return {
      isDatavantTokenizationEnabled: false,
      isDisable: false,     
      multiconsent: {
        box1: true,
        box2: true
      },
      cohorts: {
        addButton: true
      },
      dataVantStatus: [],
      existingConsents: [],
      existingCohorts: [],
      
      educationEnabled: true,
          comprehensionEnabled: true,
          documentAndSignatureEnabled: true,
          digitalSignatureEnabled: true,
      selectedConsentSection: {
        sectionId: "",
        sectionType: "default",
        sectionNumber: "",
        sectionTitle: "",
        sectionImage: "",
        sectionImageTemp: "",
        sectionSummary: "",
        sectionHtmlContent: "",
        opType: ""
      },
      consentData: {
        consentName: "",
        consentId: "",
        consentType: "default",
        opType: ""
      },
      cohort: {
        cohortName: "",
        cohortId: "",
        opType: "",
        associatedConsent: [],
        editCurrentCohort: ""
      },
      consentSections: [],
      quizQuestions: [],
      consentDocReadMode: true,
      fileSelected: null,
      studyData: {},
      branding: {},
      consentDocData: {
        file: null,
        htmlDocument: null,
        pdfLink: null
      },
      privacyPolicyOriginal: null,
      privacyPolicy: "",
      privacyReadMode: false,
      privacyPolicyOPType: "",
      licenses: null,
      licenseReadMode: false,
      addEditQuizQuestion: {
        type: "default",
        body: "",
        sequence: 1,
        description: "",
        expectedAnswer: "",
        options: [
          { body: "", sequence: 1 },
          { body: "", sequence: 2 }
        ],
        opType: ""
      },
      studyId: null,
      expand: false,
      collapse: true,
      addQuiz: false,
      editQuiz: false,
      tempDocData: null,
      editorOptionsMore: {
        placeholder: "Enter your study consent",
        readOnly: false,
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ color: [] }, { background: [] }],
            // [{ font: [] }],
            [{ align: [] }],
            ["link", "image", "video"],
            ["clean"]
          ]
        }
      },
      editorOptionsFew: {
        placeholder: "Enter your privacy policy",
        readOnly: false,
        modules: {
          toolbar: [["bold", "italic", "underline"], ["clean"]]
        }
      },
      toggleEConsent: true,
      isStudySummary: JSON.parse(window.localStorage.getItem("thread-studySummary")),
      studyDataFacts: {},

      consentEnabled: true,
      childConsentData: {},
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      dataVantConsentBasicDetails: []
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.setTimeout(() => {
      const scrollableSection = window.document.getElementById("feature_menu_scroll");
      scrollableSection.scrollLeft += 100;
    }, 1500);
    this.studyId = this.$route.params.studyId;
    this.opType = this.$route.params.opType;
    this.getExistingConsents();
    this.getExistingCohorts();
    this.getPrivacyPolicy();
    this.generateLicenseInfo();
    this.getStudyFact();
    this.startAutoSave();
    this.getDatavantTokenDetails();
  },
  computed: {},
  watch: {},
  methods: {
    generateLicenseInfo() {
      this.licenses =
        `<div class='fs-16 text-justify'><p>Hello Study Participant!</p> <p>Thank you for participating in this very important clinical trial study.  Our name is THREAD, and we are the company that owns the app that you will be using on your mobile device during your participation in this study. The goal of our app is to make your participation in this study more convenient and we certainly hope that it does just that!</p> <p>We  are  giving  you  permission  to  use  our  app  for  the  study,  which  in  legal  terms  means  that THREAD is granting you a license to use its app with certain guidelines. THREAD asks that you please review this list of guidelines and promise to follow them by signing your name below.</p><div><ul><li>You are at least 18 years old, and if you are not, then you have a parent or legal guardian’s permission to use the app.</li><li>You will not change, copy or share the app, or any part of it.</li><li>You understand that our app is not meant to provide you with any form of medical advice.</li><li>We will only grant access to the data collected on the app to those people who you approve, so please be sure that any permissions you give are correct.</li><li>We plan to provide you access to the app for as long as you are participating in the study, but under rare circumstances we may need or want to stop your access to the app and can do so without telling you first.</li><li>Once your participation in the study ends, or if you do not want to use our app any longer, you will delete the app.</li></ul></div><div> <div><p>Our aim is for this letter to be a very straightforward, uncomplicated end user license agreement and that your promises above are legal commitments made by you for the benefit of THREAD.</p></div><div><p>If  you  have  any  questions,  please  contact  us  at <a href="mailto:info@threadresearch.com">info@threadresearch.com</a>. We  wish  you  all  the best with your participation in this study and the use of the THREAD app.<br/><br/><br/><br/><p align='center'>Definitive Media Corp.<br/>(doing business as THREAD) <br/>155 El Camino Real, Suite B, Tustin, CA 92780 <br>USA<br><br> Updated: 05 October, 2020</p></div></div>`
    },  
    getDatavantTokenDetails() {
      let param = {
        studyId: this.studyId
      };

      this.$api.getDatavantToggleState(param).then(data => {
        this.isDatavantTokenizationEnabled =
          data.body && data.body.dataVantStatus;
          if(this.isDatavantTokenizationEnabled) {
            this.getDatavantConsentBasicDetails();
          }
      });
    },
    closeModal() {
      this.getExistingConsents();
      this.multiconsent.box1 = true;
      this.multiconsent.box2 = true;
      this.consentData.opType = "";
      window.scrollTo(0, 0);
    },
    deletePrivacyPolicy() {
      this.privacyPolicyOPType = "toAdd";
      this.privacyPolicy = "";
      this.privacyPolicyOriginal = "";
      this.privacyReadMode = false;
      this.multiconsent.box1 = true;
      this.multiconsent.box2 = true;
      this.getPrivacyPolicy();
    },
    cancelEditingPrivacyPolicy() {
      this.privacyPolicyOPType = "toAdd";
      this.privacyReadMode = false;
      this.multiconsent.box1 = true;
      this.multiconsent.box2 = true;
    },
    savePrivacyPolicy(privacyPolicy) {
      this.privacyPolicyOPType = "toEdit";
      this.privacyPolicy = privacyPolicy;
      this.privacyPolicyOriginal = privacyPolicy;
      this.privacyReadMode = false;
      this.multiconsent.box1 = true;
      this.multiconsent.box2 = true;
      this.getPrivacyPolicy();
    },
    goBack() {
      window.history.back();
    },
    cancelEditing() {
      this.cohort.opType = "";
      this.cohorts.addButton = true;
    },
    cancelAssociationEditing() {
      const that = this;
      that.existingCohorts = [];
      that.getExistingCohorts();
      that.cohort.editCurrentCohort = "";
      that.cohort.cohortId = "";
      that.isDisable = false;
    },
    saveCohort(addedCohort) {
      this.existingCohorts.push(addedCohort);
    },
    getDatavantConsentBasicDetails(isEdit=false) {
    nprogress.start();
        const payLoad = {studyId: this.studyId, isEdit:isEdit}
        this.$api.getOptionalConsentData(payLoad).then(
        response => {  
         this.dataVantConsentBasicDetails =  response.body;  
          },
        error => {
          toastr.error(
            error.body && error.body.message
              ? error.body.message
              : "Error while getting the datavant Consent after adding consent."
          ); // eslint-disable-line
          nprogress.done();
        }
      );
    },

    async checkDatavantConsentAndGetDetails() {
      if (this.dataVantConsentBasicDetails.length <= 0) {   
        this.getDatavantConsentDetails(true);           
          }   
           else if(this.dataVantConsentBasicDetails.length >= 0) {
            this.getDatavantConsentDetails(false);
          }
    },
 
      getDatavantConsentDetails(isEdit) {
      let self = this;
       let datavantConsentId = null;
       if ( this.dataVantConsentBasicDetails.length > 0) {      
        datavantConsentId =  this.dataVantConsentBasicDetails[0].consentId;
       }
        nprogress.start();
        this.$api.getOptionalEditConsentData(this.studyId, datavantConsentId, isEdit).then(
        response => {
          self.consentData.sections = response.data.datavantConsentData[0].sections;
          self.consentData.consentId = response.data.datavantConsentMeta[0].consentId;
          self.consentData.consentName = response.data.datavantConsentMeta[0].consentName;
          self.consentData.quiz =response.data.datavantConsentData[0].quiz;
          if(response.data.datavantConsentData[0] && response.data.datavantConsentData[0].documentProperties && response.data.datavantConsentData[0].documentProperties) {
            self.consentData.documents =response.data.datavantConsentData[0].documentProperties;
          } else if(response.data.datavantConsentData[0] && response.data.datavantConsentData[0].listOfdocumentProperties && response.data.datavantConsentData[0].listOfdocumentProperties.length > 0) {
            self.consentData.documents = response.data.datavantConsentData[0].listOfdocumentProperties;
          } else {
            self.consentData.documents = null;
          }
          self.multiconsent.box1 = false;
          self.multiconsent.box2 = false;
          self.consentData.opType = "toOptionalEdit";
          self.consentData.consentType = "default";
          self.consentData.participantVideos = response.data.datavantConsentData[0].participantVideos; 
        // sending the participant videos
          nprogress.done();
        },
        error => {
          toastr.error(
            error.body && error.body.message
              ? error.body.message
              : "Error while getting consent data after adding consent."
          ); // eslint-disable-line
          nprogress.done();
        }
        
      );
      },

    getExistingConsentData(consentId) {
      const self = this;
      nprogress.start();
      this.$api.getCosentDataApi(this.studyId, consentId).then(
        response => {
          self.consentData.sections = response.data.sections;
          self.consentData.quiz = response.data.quiz;
          if (response.data && response.data.documentProperties && response.data.documentProperties) {
            self.consentData.documents = response.data.documentProperties;
          } else if (response.data && response.data.listOfdocumentProperties && response.data.listOfdocumentProperties.length > 0) {
            self.consentData.documents = response.data.listOfdocumentProperties;
          } else {
            self.consentData.documents = null;
          }
          self.multiconsent.box1 = false;
          self.multiconsent.box2 = false;
          self.consentData.opType = "toEdit";
          self.consentData.consentType = "default";
          const selectedConsent = _.find(this.existingConsents, ["consentId", consentId]);
          self.consentData = {
            ...self.consentData,
            educationEnabled: selectedConsent.educationEnabled,
            comprehensionEnabled: selectedConsent.comprehensionEnabled,
            documentAndSignatureEnabled: selectedConsent.documentAndSignatureEnabled,
            digitalSignatureEnabled: selectedConsent.digitalSignatureEnabled
          };
          self.consentData.participantVideos = response.data.participantVideos; // sending the participant videos
          nprogress.done();
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting consent data after adding consent.");
          nprogress.done();
        }
      );
    },
    getExistingConsents() {
      nprogress.start();
      this.$api.getExistingConsentData(this.studyId).then(
        response => {
          this.existingConsents = response.data;
          nprogress.done();
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study details");
          nprogress.done();
        }
      );
    },
    getExistingCohorts() {
      nprogress.start();
      this.$api.getExistingCohorts(this.studyId).then(
        response => {
          for (let i = 0; i < response.data.length; i++) {
            this.existingCohorts.push(response.data[i]);
          }
          nprogress.done();
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study details");
          nprogress.done();
        }
      );
    },
    getPrivacyPolicy() {
      nprogress.start();
      this.$api.getStudyPrivacyPolicyFact(this.studyId).then(
        response => {
          this.privacyPolicy = response.bodyText;
          nprogress.done();
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the privacy details");
          nprogress.done();
        }
      );
    },
    // getExistingOptionalConsentSection() {
    //   nprogress.start();
    //   this.$api.getStudyPrivacyPolicyFact(this.studyId).then(
    //     response => {
    //       this.privacyPolicy = response.bodyText;
    //       nprogress.done();
    //     },
    //     error => {
    //       toastr.error(
    //         error.body && error.body.message
    //           ? error.body.message
    //           : "Error while getting the consent section"
    //       );
    //       nprogress.done();
    //     }
    //   );
    // },
    collapseFunc() {
      this.collapse = false;
      this.expand = true;
    },
    expandFunc() {
      this.collapse = true;
      this.expand = false;
    },
    viewLicenseAgreement() {
      this.licenseReadMode = true;
      this.multiconsent.box1 = false;
      this.multiconsent.box2 = false;
    },
    closeLicenseAgreementReading() {
      this.licenseReadMode = false;
      this.multiconsent.box1 = true;
      this.multiconsent.box2 = true;
    },
    editPrivacyPolicy() {
      this.privacyPolicyOPType = "toEdit";
      this.privacyReadMode = true;
      this.multiconsent.box1 = false;
      this.multiconsent.box2 = false;
    },
    addPrivacyPolicy() {
      this.privacyPolicyOPType = "toAdd";
      this.privacyReadMode = true;
      this.multiconsent.box1 = false;
      this.multiconsent.box2 = false;
    },
    addNewConsent() {
      this.consentData.opType = "toAdd";
      this.consentData.consentType = "default";

      this.multiconsent.box1 = false;
      this.multiconsent.box2 = false;
    },
    addNewOptionalConsent() {
      this.consentData.opType = "toOptionalEdit";
      this.consentData.consentType = "default";
      this.multiconsent.box1 = false;
      this.multiconsent.box2 = false;
    },
    addNewCohort() {
      this.cohort.opType = "toAdd";
      this.cohorts.addButton = false;
    },
    editConsent(v) {
      this.consentData.consentName = v.consentName;
      this.consentData.consentId = v.consentId;
      this.childConsentData = {
        comprehensionEnabled: v.comprehensionEnabled,
        documentAndSignatureEnabled: v.documentAndSignatureEnabled,
        educationEnabled: v.educationEnabled
      };
      this.getExistingConsentData(v.consentId);
    },
  

    deleteConsent(v) {
      swal({
        title: "Are you sure you want to delete this consent?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          nprogress.start();
          this.$api.deleteConsentData(this.studyId, v.consentId).then(
            () => {
              this.getExistingConsents();
              toastr.success("Consent deleted successfully.");
              nprogress.done();
            },
            error => {
              toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study details");
              nprogress.done();
            }
          );
        }
      });
    },
    deleteCohort(v) {
      const that = this;
      swal({
        title: "Are you sure you want to delete this cohort?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          nprogress.start();
          that.$api.deleteCohortData(that.studyId, v.cohortId).then(
            () => {
              const index = that.existingCohorts.findIndex(x => x.cohortId == v.cohortId);
              if (index >= 0) {
                that.existingCohorts.splice(index, 1);
              }
              that.cancelAssociationEditing();
              toastr.success("Cohort deleted successfully.");
              nprogress.done();
            },
            error => {
              toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting the cohort");
              nprogress.done();
            }
          );
        }
      });
    },
    editCohort(currentCohort) {
      this.cohort.editCurrentCohort = "toEdit";
      this.cohort.cohortId = currentCohort.cohortId;
      this.isDisable = true;
    },
    async isDatavantConsentValid() {
      if (!this.isDatavantTokenizationEnabled) {
        return true;
      }
      
      const response = await this.$api.getStudyOveriviewV2Fact(this.studyId);
      
      let datavantConsent = response.body.dataVantConsent;
      let datavantConsentData = datavantConsent.datavantConsentData[0];
      let valid = true;
      
      if (datavantConsentData.educationEnabled && !datavantConsent.educationScreensCount) {
        valid = false;
      }
      else if (datavantConsentData.comprehensionEnabled && !datavantConsent.comprehensionQuizCount) {
        valid = false;
      }        
      else if(datavantConsentData.documentAndSignatureEnabled) {
        let listOfdocumentProperties = datavantConsentData.listOfdocumentProperties;

        if(!listOfdocumentProperties) {
          valid = false;
        }
        else {
          let supportedLanguages = this.studyDataFacts.language;
          if (listOfdocumentProperties.length != supportedLanguages.length) {
            valid = false;
          }
        }
      }

      return valid;

    },
    nextClick(autoSave = false) {
      const that = this;
      if (this.studyDataFacts.consentEnabled) {
        new Promise(function(resolve) {
          const data = that.$api.getExistingConsentData(that.studyId).then(response => {
            return response.data;
          });
          resolve(data);
        }).then(resp => {
          if (!autoSave) {
            if (resp.length > 0) {
              if (that.consentData.opType == "toAdd") {
                if (!that.childConsentData.educationEnabled && !that.childConsentData.comprehensionEnabled && !that.childConsentData.documentAndSignatureEnabled) {
                  toastr.error("Please enable at least one of the sub-modules in " + that.consentData.consentName);
                  return;
                }
              } else if (that.consentData.opType == "toEdit") {
                if (!that.childConsentData.educationEnabled && !that.childConsentData.comprehensionEnabled && !that.childConsentData.documentAndSignatureEnabled) {
                  toastr.error("Please enable at least one of the sub-modules in " + that.consentData.consentName);
                  return;
                }
              } else {
                if (that.existingCohorts.length === 0) {
                  toastr.error("Please add at least one cohort");
                  return;
                }
            if (that.existingCohorts.filter(cohort => !cohort.associatedConsent || cohort.associatedConsent.length === 0).length > 0) {
                  toastr.error("No consents added");
                  return;
                }
              }
            } else {
              if (resp.length == 0) {
                toastr.error("Please add at least one consent");
                return;
              }
            }
            that.saveAndContinue();
          }
        });
      } else {
        if (!autoSave) {
          this.saveAndContinue();
        } else {
          this.saveAndContinue(true);
        }
      }
    },
    async saveAndContinue(autoSave=false) {
      
      if (this.consentData.opType == "" && this.privacyPolicyOPType == "" && !this.licenseReadMode) {
        let isDatavantConsentValid = await this.isDatavantConsentValid();
        if (!autoSave && !isDatavantConsentValid) {
          toastr.error("Please configure and upload Datavant Tokenization Consent.")
          return;
        }
      }
      
      let self = this;
      if (!autoSave) {
        this.doneReading();
      } else {
        this.doneReading(true);
      }
      this.$api.postStudyMultiConsentFact(this.studyId).then(
        () => {
          const selectedFeatures = self.$store.getters.getSelectedFeatures;

          const featureIndex = _.findIndex(selectedFeatures, ["route", self.$route.name]);

          if (!autoSave) {
            if (featureIndex === selectedFeatures.length - 1) {
              self.$router.push({ name: "features-library-final" });
            } else {
              self.$router.push({
                name: selectedFeatures[featureIndex + 1].route,
                params: { studyId: self.studyId }
              });
            }
          }
          nprogress.done();
        },
        error => {
          if (!autoSave) {
            const err = error.body && error.body.message ? error.body.message : "Error while saving the data";
            toastr.error(err);
          }
          nprogress.done();
        }
      );
    },
    skipForNow() {
      const selectedFeatures = this.$store.getters.getSelectedFeatures;
      const featureIndex = _.findIndex(selectedFeatures, ["route", this.$route.name]);
      if (featureIndex === selectedFeatures.length - 1) {
        this.$router.push({ name: "features-library-final" });
      } else {
        this.$router.push({
          name: selectedFeatures[featureIndex + 1].route,
          params: { studyId: this.studyId }
        });
      }
    },
    cancelModify() {
      this.$refs.cancelConfirmation.show();
    },
    doneReading(autoSave = false) {
      this.$api.addLicenseV2Fact(this.studyId, { licenses: this.licenses }).then(
        () => {
          if (!autoSave) {
            toastr.success("License added successfully");
          }
          nprogress.done();
        },
        error => {
          if (!autoSave) {
            toastr.error(error.body ? error.body.message : "Error while adding the license");
          }
          nprogress.done();
        }
      );
    },
    switchEConsent(event) {
      if (this.studyDataFacts.consentEnabled && !event.consentEnabled && this.existingConsents) {
        swal({
          title: "You are about to turn off this section. Any configuration you may have will be lost. Are you sure you want to delete this configuration?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            //nprogress.start();

            this.updateStudyFact(event);
          } else {
            this.studyDataFacts = {
              ...this.studyDataFacts,
              consentEnabled: true
            };
          }
        });
      } else {
        this.updateStudyFact(event);
      }
    },
    getStudyFact() {
      this.$api.getStudyDataFact(this.studyId).then(data => {
        this.studyDataFacts = data.body;
        this.toggleEConsent = this.studyDataFacts.consentEnabled;
      });
    },
    updateStudyFact(consentTypeData) {
      const studyDataFacts = {
        ...this.studyDataFacts,
        ...consentTypeData
      };

      this.$api.updateNewStudyDataFact(studyDataFacts).then(data => {
        this.studyDataFacts = data.body;

        this.toggleEConsent = this.studyDataFacts.consentEnabled;
      });
    },
    consentDataRecived(comprehensionEnabled, documentAndSignatureEnabled, educationEnabled) {
      this.childConsentData = {
        comprehensionEnabled: comprehensionEnabled,
        documentAndSignatureEnabled: documentAndSignatureEnabled,
        educationEnabled: educationEnabled
      };
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.nextClick(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    resetAutoSave() {
      this.stopAutoSave();
      this.startAutoSave();
    }
  },
  components: {
    studyFeatureHeader,
    draggable,
    addEditCohort,
    cohortConsentAssociation,
    privacyPolicy,
    licenseAgreement,
    editMultiConsent,
    CancelModal,
    StudyConsentTypeSection,
    registration,
    DatavantTokenizationModal,
    DatavantService
  },
  beforeRouteLeave(to, from, next) {
    this.nextClick(true);
    setTimeout(() => {
      next();
    }, 100);
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>

<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)

body {
  color: #333;
}

button:hover,
.blue-btn:hover,
.white-btn:hover {
  opacity: 0.5;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  margin: 20px 0 10px;
}

.h4,
h4 {
  font-size: 18px;
  margin: 10px 0;
}

.h5,
h5 {
  font-size: 14px;
  margin: 10px 0;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.color_959fa4 {
  color: #959fa4 !important;
}

.card {
  display: block;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

.bg-color {
  background-color: #f5f8fa;
  background-size: cover;
  // height: 100%;
  // min-height: 100vh;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.collapse_card {
  border: 1px solid #d3dfe4 !important;
  background-color: #f5f8fa;
  padding-left: 5px;
}
.icon_section {
  width: 28px;
  height: 28px;
  border-radius: 2px;
  background-color: #d3dfe4;
  display: inline-block;
  text-align: center;
  padding-top: 5px;
}
.read_only_card {
  border-left: 6px solid #d3dfe4 !important;
}
.navbar-style {
  background: linear-gradient(to left, #7478e6, #09b9e0);
}

.btn {
  border-radius: 25px;
}
.form-control {
  border-radius: 2px;
}
.container-style {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.consent-header {
  margin: 0px;
  padding: 40px 0px 10px 0px;
  font-weight: 500;
  font-size: 16px;
}

.card {
  border-radius: 3px;
  background-color: #f5f8fa;
  /*box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);*/
  border: solid 1px #d3dfe4;
  padding: 5px 20px;
  margin-top: 10px;
}
.doc_desc {
  display: inline-block;
  word-break: break-all;
}
.license_info {
  background-color: #eee;
  padding: 12px;
  border-radius: 2px;
  border: 1px solid #ccc;
}

.font-style {
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1f95f2;
}

.header-style {
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}
.edit_only_screen {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.add-btn {
  font-size: 14px;
  min-width: 150px;
  border: 1px solid#f06559;
  color: #f06559;
  background: transparent;
}

.save_btn {
  width: 100px;
}

.misplaced-card {
  border-radius: 8px;
  background-color: #ffffff;
  border: solid 1px #d3dfe4;
}

.edit-btn {
  padding: 5px 15px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #d3dfe4;
  color: #1f95f2;
}

.radio-style {
  bottom: 2px;
  text-align: center;
}

.close-style {
  padding: 25px 30px 10px 0px !important;
}

.align_justify {
  text-align: justify;
}

.disable-row {
  pointer-events: none;
  opacity: 0.2;
}

.btn {
  padding: 0;
  float: right;
  cursor: pointer;

  button {
    &.white-btn {
      width: 100px;
      height: 36px;
      border-radius: 3px;
      font-family: Lato-Regular;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #1e8fe1;
      border: solid 1px #1e8fe1;
      background-color: #ffffff;
    }

    &.blue-btn {
      width: 100px;
      height: 36px;
      border-radius: 3px;
      font-family: Lato-Regular;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      border: solid 1px #1e8fe1;
      background-color: #1e8fe1;
    }
  }
}
.cohort-consent-name {
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-top: 5px;
}
.delete-div {
  margin-bottom: 20px;
  vertical-align: middle;
  margin-top: 20px;

  .delete-icon {
    cursor: pointer;
  }
}
</style>
<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
button {
  cursor: pointer;
}
.consent-cohort-section {
  border-radius: 0px 0px 4px 4px;
  border: solid 1px #e4e8eb;
  /* margin-top: 40px; */
  margin-left: 30px;
  margin-right: 30px;
}
.multiconsent-box1 {
  background-color: #ffffff;
  margin: 20px;
}
.disable-consent {
  opacity: 0.5;
  // pointer-events: none;
}

.multiconsent-box1-heading1 {
  font-family: Lato-Regular;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: #2d3752;
}

.multiconsent-box1-content1 {
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.multiconsent-box1-bottom {
  margin-top: 20px;

  .consent-name {
    font-family: Lato-Regular;
    font-size: 17px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.29;
    letter-spacing: normal;
    color: #4a4a4a;
  }

  .edit-icon {
    margin-left: 30px;
    cursor: pointer;
  }
}

.multiconsent-box1-btn1 {
  padding-top: 20px;
}

.consent-sub-section-divider {
  width: 100%;
  height: 1px;
  background-color: #e4e8eb;
}

.multiconsent-box1-divider,
.multiconsent-box2-divider,
.multiconsent-box3-divider {
  width: 1040px;
  height: 1px;
  background-color: #e4e8eb;
  margin-top: 30px;
}

.multiconsent-box3-divider {
  margin-top: 10px;
}

.multiconsent-box1-content2 {
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #9b9b9b;
  margin-top: 20px;
}

.multiconsent-box2 {
  background-color: #ffffff;
  margin: 20px;
}

.multiconsent-box2-heading1 {
  font-family: Lato-Regular;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: #2d3752;
}

.multiconsent-box2-content1 {
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.multiconsent-box2-btn1 {
  padding-top: 20px;
}

.multiconsent-box2-divider {
  width: 1040px;
  height: 1px;
  background-color: #e4e8eb;
  margin-top: 30px;
}

.multiconsent-box2-content2 {
  font-family: Lato-Regular;
  font-size: 17px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.multiconsent-box2-bottom {
  margin-top: 20px;
}
.optionalmulticonsent-box1 {
  background-color: #ffffff;
  margin: 20px;
}
.optionalmulticonsent-box1-heading1 {
  font-family: Lato-Regular;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: #2d3752;
}

.optionalmulticonsent-box1-content1 {
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.optionalmulticonsent-box1-content2 {
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #9b9b9b;
}
.required-field::after {
  content: "*";
  color: red;
}


.left-block {
  float: left;
}

.right-block {
  float: right;
}

.clearfix {
  clear: both;
}

.white-btn {
  color: #1e8fe1;
  border-radius: 4px;
  border: solid 1px #1e8fe1;
  background-color: #ffffff;
}

.white-btn:hover {
  opacity: 0.9;
}

.colored-btn {
  border-radius: 4px;
  border: solid 2px #ffffff;
  background-color: #1e8fe1;
  color: #fff;
}

.add-consent-btn {
  width: 190px;
  height: 30px;
  font-family: Lato-Regular;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1e8fe1;
}

.add-cohort-btn {
  width: 150px;
  height: 30px;
  font-family: Lato-Regular;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1e8fe1;
}

.select-consent-btn {
  width: 120px;
  height: 30px;
  font-family: Lato-Regular;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.multiconsent-box3 {
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  margin-top: 40px;
  margin-left: 30px;
  margin-right: 30px;
  padding: 20px;
}

.multiconsent-box3-heading1 {
  font-family: Lato-Regular;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: #2d3752;
}

.multiconsent-box3-bottom1 {
  margin-top: 20px;
}

.multiconsent-box3-bottom2 {
  margin-top: 24px;
}

.multiconsent-box3-bottom1-content1 {
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.add-privacy-policy-btn {
  width: 140px;
  height: 30px;
  font-family: Lato-Regular;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1e8fe1;
}

.multiconsent-box3-bottom2-content1 {
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.link {
  font-family: Lato-Regular;
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #1e8fe1;
  cursor: pointer;
}
/deep/.vue-switcher {
  height: 7px;
}
/deep/.vue-switcher-theme--custom {
  &.vue-switcher-color--green {
    div {
      background-color: #fff;
      border: 1px solid #2ebd59;
      width: 32px;
      height: 20px;
      &:after {
        // for the circle on the switch :
        background-color: #2ebd59;
        border: 1px solid #2ebd59;
        margin-left: -16px;
        top: 2px;
        height: 13px;
        width: 13px;
      }
    }
    &.vue-switcher input {
      height: 5px;
    }
    &.vue-switcher--unchecked {
      div {
        background-color: #fff;
        border: 1px solid #b0bac9;
        width: 32px;
        height: 20px;
        &:after {
          background-color: #b0bac9;
          border: 1px solid #b0bac9;
          margin-left: 3px;
          left: 0px !important;
          top: 2.46px;
          height: 13px;
          width: 13px;
        }
      }
    }
  }
}
.switch-container {
  position: relative;
  float: right;
  width: auto;
  right: 83px;
  & .text {
    font-family: RobotoRegular;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #b0bac9;
    &.on {
      position: absolute;
      top: -2px;
      left: 61px;
    }
    &.off {
      position: absolute;
      top: -2px;
    }
  }
  & .switch {
    height: 12px;
    position: absolute;
    top: 5px;
    left: 19px;
    margin: 0 3px;
  }
}
.disabled-icon {
  pointer-events: none;
}
.required-box {
  width: 64px;
  height: 25px;
  border-radius: 4px;
  background-color: #b0bac9;
  font-family: RobotoRegular;
  font-size: 12px;
  color: #ffffff;
  padding-left: 8px;
  padding-top: 3px;
}
</style>
